import SecureLayout from './SecureLayout'

export default SecureLayout
